let url

let ENV = process.env.NODE_ENV
// console.log(ENV)

if (ENV === 'development') {
  //开发环境 do something
  // url = 'https://testapi.yingsuyun.com'//测试地址
  url = 'http://47.92.94.162:30003'//测试地址
} else {
  //生产环境 do something
  url = 'https://api.yingsuyun.com'//正式地址
}


export const baseUrl = url
